import React from 'react'
import { RadioCircle, RadioInner, RadioLabel ,RadioButtonListContainer} from './styled'
import { Text2 } from '../../ui/text'
import theme from '../../../styled/theme'
import useIsMobile from '../../../hooks/useIsMobile'

export const RadioButton = ({ checked, onChange, label, labelPosition = 'after' }) => {
  return (
    <RadioLabel onClick={onChange}>
      {
        labelPosition === 'before' && (
          <Text2 color={theme.colors.text.primaryText}>{label}</Text2>
        )
      }
      <RadioCircle checked={checked}>
        <RadioInner checked={checked} />
      </RadioCircle>
        {
        labelPosition === 'after' && (
          <Text2 color={theme.colors.text.primaryText}>{label}</Text2>
        )
      }
    </RadioLabel>
  )
}

const RadioButtonList = ({
  options = [],
  selected,
  onChange = () => {},
  maxWidth,
  labelPosition,
}) => {
  return (
    <RadioButtonListContainer maxWidth={maxWidth}>
      {options.map(option => (
        <RadioButton
          key={option.id}
          checked={selected === option.id}
          onChange={() => onChange(option.id)}
          label={option.label}
          labelPosition={labelPosition}
        />
      ))}
    </RadioButtonListContainer>
  )
}

export default RadioButtonList
